import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';
import { api } from './api';

export default function BillingReturn() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState('checking');
  const sid = params.get('session_id');

  useEffect(() => {
    let tries = 0;
    const poll = async () => {
      if (!sid) { setState('error'); return; }
      try {
        const { data } = await api.get(`/billing/checkout/status/${sid}`);
        if (data.payment_status === 'paid') { setState('paid'); return; }
        if (data.status === 'expired' || tries > 10) { setState('error'); return; }
      } catch { setState('error'); return; }
      tries += 1; setTimeout(poll, 2000);
    };
    poll();
    /* eslint-disable-next-line */
  }, [sid]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center p-6 font-sans">
      <div className="text-center max-w-sm" data-testid="billing-return">
        {state === 'checking' && <><Loader2 size={48} className="animate-spin mx-auto text-[#00BFFF] mb-4" /><h1 className="text-xl font-black">Confirming your payment…</h1></>}
        {state === 'paid' && <>
          <CheckCircle2 size={56} className="mx-auto text-[#00D26A] mb-4" />
          <h1 className="text-2xl font-black">You're all set!</h1>
          <p className="text-gray-400 mt-2">Your plan is active. Time to run your tournament.</p>
          <button data-testid="billing-go-dashboard" onClick={() => nav('/tournaments')} className="mt-6 bg-[#00BFFF] text-black font-bold px-6 py-3 rounded-xl">Go to dashboard</button>
        </>}
        {state === 'error' && <>
          <XCircle size={56} className="mx-auto text-[#FF3B30] mb-4" />
          <h1 className="text-xl font-black">Payment not completed</h1>
          <p className="text-gray-400 mt-2">No charge was made. You can try again from Pricing.</p>
          <button onClick={() => nav('/pricing')} className="mt-6 bg-[#1C1C1E] border border-gray-700 font-bold px-6 py-3 rounded-xl">Back to Pricing</button>
        </>}
      </div>
    </div>
  );
}
